import { AxiosInstance } from "axios"
import { ServiceCenterDetailsEntry } from "./serviceCenterTypes"

export enum ServiceCenterQuery {
    SERVICE_CENTER_DETAILS = "service-center-details",
}

type ServiceCenterParams = Readonly<{
    serviceCenterId: number
}>
export type ServiceCenterDetailsResponse = Readonly<{
    serviceCenter: ServiceCenterDetailsEntry
}>

export async function fetchServiceCenterDetails(
    { serviceCenterId }: ServiceCenterParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceCenterDetailsResponse> {
    const url = `/serviceCenters/${serviceCenterId}`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
